(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("ChangeEmployeePositionModal", ChangeEmployeePositionModal);

    ChangeEmployeePositionModal.$inject = ['$scope', '$timeout', '$filter', 'modalData', 'onBoardingService', 'positionsDataService'];

    function ChangeEmployeePositionModal($scope, $timeout, $filter, modalData, onBoardingService, positionsDataService) {

        var self = this;
        var brandId;
        var userId;
        var myDocsCardId;

        self.$onInit = function () {
            var usersIds = modalData.usersIds || [];

            if (!usersIds.length) {
                throw 'ChangeEmployeePositionModal Need users ids to work';
            }

            if (!modalData.brandId) {
                throw 'ChangeEmployeePositionModal Need brand id';
            }

            brandId = modalData.brandId;
            userId = usersIds[0];
            myDocsCardId = modalData.cardId;

            positionsDataService.getActivePositionsFlat(false, brandId)
                .then(function (positions) {
                    self.positions = positions.filter(function (position) {
                        return activePositions.indexOf(position.code) === -1;
                    });
                });

            var usersFromServicePositions = onBoardingService.getUsersPositions(brandId, usersIds);
            var usersPositions = usersFromServicePositions[usersIds[0]];
            var activePositions = usersPositions.map(function (position) {
                return position.code;
            });

            usersPositions.forEach(function (userPosition) {
                userPosition.category = {};
                userPosition.category.name = userPosition.position_type.name;
            });

            self.userPositions = usersPositions;
            self.userPosition = self.userPositions[0];
            self.sendObDocuments = true;

            self.formValidation = new (function () {
                BaseForm.call(this, 'move-employee-position', $scope);
            })();

            $timeout(function () {
                self.formValidation.onViewLoaded();
            }, 1);
        };

        self.close = function () {
            $scope.$hide();
        };

        self.moveEmployees = function () {
            var moveEmployees = function() {
                if (self.formValidation.validator.validate()) {
                self.modalState = 'moving';

                var prospects = [{
                    id: self.userPosition.prospect_id,
                    to_position_id: self.position.id
                }];

                onBoardingService
                    .moveEmployeesToAnotherPosition(brandId, prospects)
                    .then(function (response) {
                        self.modalState = 'moved';
                        var createdProspects = response.created_prospects || [];
                        var failedProspects = response.failed_prospects || [];

                        if (createdProspects.length > 0) {
                            self.close();

                            var newProspectId = createdProspects[0].id;
                            var user = onBoardingService.getUserDetails(userId);

                            onBoardingService.trigger('employees-moved', 'MOVE_EMPLOYEE_POSITION', {
                                actions: [{
                                    sendObDocuments: self.sendObDocuments,
                                    user_id: userId,
                                    positions: self.userPositions,
                                    position: self.position,
                                    name: user.first_name + ' ' + user.last_name,
                                    prospect_id: newProspectId,
                                    cardId: myDocsCardId,
                                    default_prospects: [user.default_prospect],
                                    brand_id: brandId,
                                    first_name: user.first_name,
                                    last_name: user.last_name
                                }]
                            });
                        } else {
                            var errorMessage = "";

                            for (var i in failedProspects) {
                                var failed = failedProspects[i];

                                switch (failed.reason_code) {
                                    case 'PROSPECT_NOT_HIRED':
                                        errorMessage += "You need to hire the employee before move it";
                                        break;
                                }
                            }

                            hAlert(
                                'Move Employee Status',
                                errorMessage,
                                function () {
                                    onBoardingService.trigger('employees-moved', 'MOVE_FAILED', {});
                                },
                                'h-general-error-alert'
                            );
                        }
                    }, function (error) {
                        delete self.modalState;
                        var errorMessage = $filter("translate")("Something went wrong, please try again.");
                        if (error.data.status_code === 403) {
                            errorMessage = $filter("translate")("You don't have permission to do this action.");
                        }
                        hAlert(
                            $filter('translate')('Error'),
                            errorMessage
                        );
                    });
            }
            };

            if (modalData.startDate > new Date()) {
                hConfirm({
                    title: $filter('translate')('Change employee position'),
                    text: $filter('translate')('This employee has a start date in the future, by changing the employee position now it’ll set their start date to today’s, are you sure you want to continue?'),
                    confirmButton: $filter('translate')('Update'),
                    cancelButton: $filter('translate')('Cancel'),
                    callback: function (confirmed) {
                        if (confirmed) {
                            moveEmployees();
                        }
                    }
                });
            } else {
                moveEmployees();
            }
        };

        self.toggleUserPosition = function (items) {};

        self.togglePosition = function (items) {};

        self.$onInit();
    }
})();